<template>
  <div :id="id" class="wf-fixed wf-z-20" :class="elementPositionClasses" :style="sizeStyles">
    <div
      class="wf-relative"
      :class="! $root.previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-4 wf-pb-2 wf-px-1' : ''"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <EditorOptions
        parent="component"
        v-show="hover && ! $root.previewMode"
        :options="menuOptions"
      />
      <div class="wf-bg-white" :class="elementClasses(classes('classes'), classes('customClasses'))" :style="elementStyles(styles('styles'))">
        <div class="wf-text-xs wf-text-right wf-uppercase wf-font-bold">Emmet Brown from Hill Valley, CA</div>
        <div class="wf-text-xs wf-text-right wf-lowercase wf-font-light wf-mt-1">
          <span v-text="content.message"></span> <span class="wf-font-bold">Flux Capacitor</span>
        </div>
        <div class="wf-flex wf-justify-between wf-text-xs wf-mt-1">
          <span class="wf-text-blue-600">27 minutes ago</span>
          <span v-show="content.withVerified" class="wf-font-bold wf-text-yellow-600"><i class="fas fa-check-circle"></i> <span v-text="content.verifiedMessage"></span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ConstantsParser } from '../ConstantsParser'
  import EditorPageComponent from '../contracts/EditorPageComponent'
  export default EditorPageComponent.extend({
    data() {
      return {
        sizeStyles: {}
      }
    },
    mounted() {
      this.calculateSize()
    },
    computed: {
      elementPositionClasses() {
        return (new ConstantsParser(this.positionClasses)).parse()
      },
      positionClasses() {
        let positionClasses = ['HorizontalPosition', 'VerticalPosition']
        return this.classes('containerClasses')[this.device].filter(containerClass => positionClasses.includes(containerClass.property))
      },
    },
    methods: {
      calculateSize() {
        let element = document.getElementById(this.id)
        if (! element) {
          return
        }
        this.sizeStyles = {width: `${element.clientWidth}px`, height: `${element.clientHeight}px`}
      }
    }
  })
</script>